// extracted by mini-css-extract-plugin
export default {"table":"OrganizationUsersTable_table__N-Lyh","row":"OrganizationUsersTable_row__IgfpQ","text":"OrganizationUsersTable_text__thV+6","actions":"OrganizationUsersTable_actions__cfYPk"};